import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Props {
  name: string;
  path?: string;
  arrow?: boolean;
  items?: Array<{
    name: string;
    path: string;
  }>;
}

const NavItem = (props: Props) => {
  const [hover, setHover] = useState<string>("");
  useEffect(() => {
    document.getElementById(`hover${props.name}`)?.addEventListener("mouseover", () => setHover(props.name));
    document.getElementById(`hover${props.name}`)?.addEventListener("mouseout", () => setHover("false"));
  }, [props.name]);
  let items = [];
  if (props.items) {
    for (let i = 0; i < props.items.length; i++) items.push(<NavItem name={props.items[i].name} path={props.items[i].path} />);
  }
  if (props.path) {
    return (
      <Link className="navitem" to={props.path}>
        {props.name}
      </Link>
    );
  } else if (props.items) {
    return (
      <div className="navitem" id={`hover${props.name}`}>
        <NavItem name={props.name} arrow={true} />
        {hover === props.name && <div className="hovered">{items}</div>}
      </div>
    );
  } else {
    return (
      <div className="navitem">
        {props.name}
        {props.arrow ? "▼" : ""}
      </div>
    );
  }
};

export default NavItem;
